import "./utils/day";
import "antd/dist/reset.css";
import "./App.css";

import React, { useEffect, Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";

import { actionCreators } from "./redux/store";
import { getLoggedInUserApi, searchUserByIdApi } from "./utils/Api";
import { getLoggedInUserDataFromLS } from "./utils/services";

import useSocket from "./hook/useSocket";
import useIsIOS from "./hook/useIsIOS";

import { Loader } from "./Layouts/Loader/Loader";

// Lazy load routes and modal
const AllRoutes = React.lazy(() => import("./routes/AllRoutes"));
const UpdateCountryModal = React.lazy(() =>
  import("./Layouts/modal/updateCountry/UpdateCountry")
);

function App() {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.user);
  const { isLoading, refresh } = useSelector((state) => state.other);
  const { roomLoading } = useSelector((state) => state.debate);
  const isIos = useIsIOS();

  const { AddLoggedInUser, setIsLoading } = bindActionCreators(
    actionCreators,
    dispatch
  );

  useSocket();

  useEffect(() => {
    fetchCurrentUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, isIos]);

  const fetchCurrentUser = async () => {
    setIsLoading(true);
    try {
      if (isIos) {
        const user = getLoggedInUserDataFromLS();
        if (user?.user_id) {
          const { data, status } = await searchUserByIdApi(user.user_id);
          if (status === 200) {
            AddLoggedInUser(data?.message?.[0]);
          }
        }
      } else {
        const res = await getLoggedInUserApi();
        if (res.status === 200) {
          AddLoggedInUser(res.data.message);
        } else {
          throw new Error("You are not logged in");
        }
      }
    } catch (error) {
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Suspense fallback={<Loader />}>
      <div className="App">
        {data?._id && (!data?.country || !data?.timeZone) && (
          <UpdateCountryModal />
        )}
        {(roomLoading || isLoading) && <Loader />}
        <AllRoutes user={data} />
      </div>
    </Suspense>
  );
}

export default App;
